<pre contenteditable style="padding:1rem;">
  {json}
</pre>

<script>
  import { onMount } from 'svelte'
  import { createAndAlterTablesDDL } from './db-schema'

  export let 
    recordDef = {};

  let json = '';

  onMount(() => {
    json = createAndAlterTablesDDL(recordDef)
  })

</script>

<style>
  .header {
    text-align: left;
    padding-top: 1.6rem;
    font-size: 16px;
  }

  .subheader {
    text-align: left;
    padding-top: 8px;
    color: #999;
    font-size: 12px;
    font-weight: normal;
  }

  td {
    font-size: 15px;
    padding-top: 4px;
    padding-bottom: 4px;
    border-bottom: 1px solid #ccc;
  }
</style>